import { ConferencingType } from "@clockwise/schema";
import { useEcosystem } from "@clockwise/web-commons/src/util/ecosystem";
import { useZoomAccount } from "./useZoom";

export const useUserConfrencingTypes = () => {
  const ecosystem = useEcosystem();
  const { enabled: canUseZoom } = useZoomAccount();

  const conferencingTypes: ConferencingType[] = [];

  const canUseTeams = ecosystem === "Microsoft";
  const canUseMeet = ecosystem === "Google";

  if (canUseZoom) {
    conferencingTypes.push("ZOOM" as ConferencingType);
  }
  if (canUseTeams) {
    conferencingTypes.push("TEAMS_FOR_BUSINESS" as ConferencingType);
  }
  if (canUseMeet) {
    conferencingTypes.push("MEET" as ConferencingType);
  }

  return { conferencingTypes, canUseTeams, canUseMeet, canUseZoom };
};
